import React, { useEffect, useRef, useState } from "react";
// Variant B ki ye screen bilkul wahi dikhni chahiye jo GoLiveWizard ke andar
// ImmediateOwnerShip apne "inline picker" mode me dikhata hai. Isliye CSS module
// SEEDHA wahi reuse kar rahe hain — copy-paste karke doosri CSS banate to dono
// screens time ke saath alag dikhne lagti.
import styles from "../../ImmediateOwnerShip/ImmediateOwnerShip.module.css";
import AnimatedButton from "../../AnimatedButton/AnimatedButton";
import Loader2 from "../../Loader2/Loader2";
import GoogleAddressInputWithDropdown from "../../GoogleAddressInputWithDropdown/GoogleAddressInputWithDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { useAgentStore } from "../../../Store/agentDetailStore";
import {
    createNumberOrder,
    createVobizNumberOrder,
    fetchAgentDetailById,
    fetchAvailablePhoneNumberByCountry,
    fetchAvailableVobizNumbers,
    updateAgent,
} from "../../../Store/apiStore";
import PopUp from "../../Popup/Popup";
import { CELEBRATE_KEY } from "../AgentLive/AgentLive";
import { trackEvent } from "../../../lib/analytics";
import { useGlobalCall } from "../../../contexts/GlobalCallContext";
import { markSetupStep } from "../../../lib/setupScore";
// Kaunse country ka number mil sakta hai ye site pe depend karta hai: India
// site Vobiz se kharidti hai (sirf IN), baaki Telnyx se (US/CA). Yahan US/CA
// hardcode tha, is liye India pe har address reject ho jaata tha aur Vobiz ki
// API tak call pahunchti hi nahi thi.
import {
    IN_DEFAULT_LOCATION,
    isPythonBackend,
    isSupportedNumberCountry,
    unsupportedNumberCountryMessage,
    usesVobiz,
} from "../../../utils/apiBackend";

// Provider ke hisaab se function chuno. Telnyx wali functions bilkul waise hi
// hain jaise pehle thi — unhe chhua nahi gaya, kyunki wahi live US/AppSumo
// flow chalati hain. Vobiz ke liye apne alag functions hain.
const searchNumbers = (...args) =>
    usesVobiz()
        ? fetchAvailableVobizNumbers(...args)
        : fetchAvailablePhoneNumberByCountry(...args);

const orderNumber = (...args) =>
    usesVobiz() ? createVobizNumberOrder(...args) : createNumberOrder(...args);

// On the India site every number comes from one pool, so there is nothing for
// the owner to choose a city for. The location field is hidden there and this
// is what we search with instead — shared with every other purchase screen so
// they cannot drift apart.

/*
 * ReceptionistNumber — Variant B, screen 2 of 3.
 *
 *   /fast-step ("Go Live with <agent>")
 *      → /receptionist-number   ← YE SCREEN
 *      → /agent-live
 *
 * Variant A (jo aaj chal raha hai) is screen ko kabhi nahi dekhta — wo seedha
 * /recommended-plan pe jaata hai. Dono flows alag components me hain taaki
 * experiment control flow ko chhu na sake.
 *
 * NUMBER KAHAN SE AATA HAI:
 *   1. Agent pe number pehle se assigned ho → wahi dikhao.
 *   2. Warna BUSINESS KI LOCATION se available numbers search karke pehla
 *      number propose karo (city/state/country business record se aate hain).
 *   3. User "Find More Options" se doosri city bhi search kar sakta hai.
 *
 * ASSIGNMENT:
 *   "Continue with this number" par wahi sequence chalta hai jo NumberAssign.js
 *   me hai — createNumberOrder (Telnyx purchase) + updateAgent (agent row pe
 *   voip_numbers set). Agent pe number pehle se ho to dono skip ho jaate hain,
 *   isliye Continue dubara dabane se doosra number nahi khareeda jaata.
 *
 * ROUTE NOTE: path single-segment hona chahiye (/receptionist-number). Shared
 * AnimatedButton apna background <img src="svg/..."> RELATIVE deta hai, to
 * nested path (/b/...) pe wo 404 ho jaata aur button ki jagah broken image
 * dikhti hai.
 */

// voip_numbers API se kabhi array aata hai, kabhi JSON string, kabhi plain
// string. Teeno shapes handle karo — wahi defensive parse jo ImmediateOwnerShip
// aur GoLiveCelebration me hai.
const parseVoipNumber = (raw) => {
    if (!raw) return "";
    if (Array.isArray(raw)) return raw[0] || "";
    if (typeof raw === "string") {
        if (raw.trim().startsWith("[")) {
            try {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed[0] || "" : parsed || "";
            } catch {
                return raw;
            }
        }
        return raw;
    }
    return "";
};

// Naam US_CA_ONLY hi rakha hai kyunki neeche render me isi se compare hota hai;
// text ab site ke hisaab se aata hai (India pe "Only India numbers...").
const US_CA_ONLY = unsupportedNumberCountryMessage();

const ReceptionistNumber = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { agentData, setAgentById } = useAgentStore();
    // Call is screen ke doran bhi live rehti hai (banner uska UI hai), isliye
    // agent ko batana zaroori hai ki user ab kya dekh raha hai.
    const { injectContext, callStatus } = useGlobalCall();
    const introInjectedRef = useRef(false);

    // Screen pe dikhne wala number. Ya to agent pe assigned hai, ya business ki
    // location se search karke propose kiya gaya hai.
    const [selectedNumber, setSelectedNumber] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [copiedFlash, setCopiedFlash] = useState(false);
    const [agentDetails, setAgentDetails] = useState(null);
    const [businessDetails, setBusinessDetails] = useState(null);
    // Number agent pe pehle se assigned hai (sirf propose nahi kiya gaya)? Isi se
    // tay hota hai ki Continue par purchase chalana hai ya seedha aage jaana hai.
    const [isAssigned, setIsAssigned] = useState(false);
    const [assigning, setAssigning] = useState(false);
    // Double-tap / re-render guard — do number kabhi na khareede jaayein.
    const assignRunningRef = useRef(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("success");

    // ── "Find More Options" picker ────────────────────────────────────
    const [pickerOpen, setPickerOpen] = useState(false);
    const [pickerNumbers, setPickerNumbers] = useState([]);
    const [pickerSelectedNumber, setPickerSelectedNumber] = useState("");
    const [pickerCity, setPickerCity] = useState("");
    const [pickerState, setPickerState] = useState("");
    const [pickerCountry, setPickerCountry] = useState("");
    const [pickerLoading, setPickerLoading] = useState(false);
    const [pickerError, setPickerError] = useState("");
    const [pickerLocationAddress, setPickerLocationAddress] = useState("");
    const pickerDebounceRef = useRef(null);
    const pickerGoogleInputRef = useRef(null);
    // Picker khulte waqt hum address field ko seed karte hain. Us programmatic
    // set ko user-typing samajh ke dobara search na chala den, isliye ek baar skip.
    const pickerSeededRef = useRef(false);

    const token = localStorage.getItem("token") || "";
    const agentId = location?.state?.agentId || sessionStorage.getItem("SelectAgentId");
    const agentBuisnesId = location?.state?.businessId || sessionStorage.getItem("SelectAgentBusinessId");
    const isPounce =
        location?.state?.fromPounce ||
        sessionStorage.getItem("SelectAgentRole") === "pounce" ||
        sessionStorage.getItem("onboardingFlow") === "pounce";

    const agentDisplayName = (
        agentDetails?.agentName ||
        agentData?.agent?.agentName ||
        ""
    ).trim();

    // Business ki location — number isi ke hisaab se search hota hai.
    const bizCountry = (businessDetails?.country_code || "").toString().toUpperCase();
    const bizCity = businessDetails?.city || "";
    const bizState = businessDetails?.state_code || businessDetails?.state || "";

    // Subtitle me "premium, local <city> number" — jo city ka number mila wahi
    // dikhao (picker se doosri city chuni ho to wo), warna business ki city.
    const cityDisplay = pickerCity || bizCity || "US";

    // Location ke hisaab se available numbers laao. US/CA ke bahar Telnyx se
    // numbers milte hi nahi, isliye pehle hi rok dete hain.
    const fetchNumbersFor = async (countryCode, cityName, stateCode) => {
        const upper = (countryCode || "").toUpperCase();
        if (!upper) return [];
        if (!isSupportedNumberCountry(upper)) {
            setPickerNumbers([]);
            setPickerSelectedNumber("");
            setPickerError(US_CA_ONLY);
            return [];
        }
        setPickerLoading(true);
        setPickerError("");
        try {
            const res = await searchNumbers(
                token,
                upper,
                cityName || "",
                stateCode || "",
                null,
                null
            );
            const list = res?.data || [];
            setPickerNumbers(list);
            setPickerSelectedNumber(list[0]?.phone_number || "");
            return list;
        } catch (err) {
            console.error("[ReceptionistNumber] number search failed:", err);
            setPickerError("Couldn't load numbers for this location. Please try again.");
            setPickerNumbers([]);
            return [];
        } finally {
            setPickerLoading(false);
        }
    };

    // Google Geocoder se typed address → country/city/state, phir search.
    const parseAddressAndFetch = (address) => {
        if (!address || address.length < 3) return;
        if (typeof window === "undefined" || !window.google?.maps?.Geocoder) {
            setPickerError("Address lookup unavailable. Please try again in a moment.");
            return;
        }
        setPickerLoading(true);
        setPickerError("");
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            if (status !== "OK" || !results?.[0]) {
                setPickerLoading(false);
                setPickerError(
                    status === "ZERO_RESULTS"
                        ? "No matching location found. Try a city + state."
                        : "Couldn't look up that address. Please try again."
                );
                return;
            }
            let cityName = "";
            let stateCode = "";
            let countryCode = "";
            results[0].address_components.forEach((c) => {
                if (c.types.includes("locality")) cityName = c.long_name;
                if (c.types.includes("administrative_area_level_1")) stateCode = c.short_name;
                if (c.types.includes("country")) countryCode = c.short_name;
            });
            if (!countryCode) {
                setPickerLoading(false);
                setPickerError(
                    "Couldn't determine country from that address. Please try a more specific location."
                );
                return;
            }
            const upper = countryCode.toUpperCase();
            setPickerCountry(upper);
            setPickerCity(cityName);
            setPickerState(stateCode);
            if (!isSupportedNumberCountry(upper)) {
                setPickerLoading(false);
                setPickerError(US_CA_ONLY);
                return;
            }
            fetchNumbersFor(upper, cityName, stateCode);
        });
    };

    // Type karte hi har keystroke pe geocode + search na chale — 1.5s ruk jao.
    useEffect(() => {
        if (!pickerOpen) return undefined;
        if (!pickerLocationAddress || pickerLocationAddress.length < 3) return undefined;
        if (pickerSeededRef.current) {
            // Ye hamara khud ka seed tha, user ka typing nahi.
            pickerSeededRef.current = false;
            return undefined;
        }
        if (pickerDebounceRef.current) clearTimeout(pickerDebounceRef.current);
        pickerDebounceRef.current = setTimeout(() => {
            parseAddressAndFetch(pickerLocationAddress);
        }, 1500);
        return () => {
            if (pickerDebounceRef.current) clearTimeout(pickerDebounceRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pickerLocationAddress, pickerOpen]);

    // Agent + business laao. Number pehle se assigned ho to wahi; warna business
    // ki location se search karke pehla number propose kar do.
    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!agentId) {
                setIsLoading(false);
                return;
            }
            try {
                const response = await fetchAgentDetailById({
                    agentId,
                    bussinesId: agentBuisnesId,
                });
                if (cancelled) return;
                const agentInfo = response?.data;
                const biz = agentInfo?.business || agentInfo?.businessName || null;

                setAgentDetails(agentInfo?.agent || null);
                setBusinessDetails(biz);
                setAgentById(agentId, agentInfo, [], 0);

                const assigned = parseVoipNumber(agentInfo?.agent?.voip_numbers);
                if (assigned) {
                    setSelectedNumber(assigned);
                    setIsAssigned(true);
                    return;
                }

                // Koi number assigned nahi → business ki location se dhoondo.
                // India site pe location poochhne ka matlab nahi (poora pool ek
                // hi hai), isliye seedha Bangalore se.
                const country = usesVobiz()
                    ? "IN"
                    : (biz?.country_code || "").toString().toUpperCase();
                const city = usesVobiz() ? IN_DEFAULT_LOCATION.city : biz?.city || "";
                const stateCode = usesVobiz()
                    ? IN_DEFAULT_LOCATION.stateCode
                    : biz?.state_code || biz?.state || "";
                if (!country) {
                    setPickerError(
                        usesVobiz()
                            ? "Couldn't determine your business location."
                            : "Couldn't determine your business location. Use Find More Options to search a city."
                    );
                    return;
                }
                setPickerCountry(country);
                setPickerCity(city);
                setPickerState(stateCode);
                const list = await fetchNumbersFor(country, city, stateCode);
                if (!cancelled && list[0]?.phone_number) {
                    setSelectedNumber(list[0].phone_number);
                }
            } catch (err) {
                console.error("[ReceptionistNumber] agent detail fetch failed:", err);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agentId, agentBuisnesId]);

    /*
     * Screen pe aate hi live call me context inject karo.
     *
     * Agent ne abhi tak sirf /fast-step wali baat ki hai; ab user ek NAYI screen
     * pe hai jahan uska phone number dikh raha hai. Bina bataye agent purani hi
     * baat karta rahega ya chup ho jayega.
     *
     * Number aane ka wait karte hain taaki agent use bol sake — par agar number
     * na mile (US/CA ke bahar, ya search khaali) to loading khatam hote hi bina
     * number wala context bhej dete hain, warna inject kabhi jaata hi nahi.
     *
     * Ek hi baar — injectContext khud bhi duplicate text drop karta hai, par
     * ref se hum re-render pe dobara koshish hi nahi karte.
     */
    useEffect(() => {
        if (introInjectedRef.current) return;
        if (callStatus !== "active") return;
        if (!selectedNumber && isLoading) return; // number ka thoda wait
        introInjectedRef.current = true;

        const who = agentDisplayName || "the receptionist";
        injectContext(
            selectedNumber
                ? `CONTEXT: The customer has just moved to the "Your Receptionist's Number" screen. They can now see the local business number ${selectedNumber} that has been picked for you (${who}), along with a "Continue with this number" button. Continue the SAME conversation naturally — do NOT restart, do NOT re-introduce yourself, do NOT repeat your greeting. In ONE short, warm sentence, point out that this is their new business number and invite them to tap "Continue with this number" to lock it in. Never pushy.`
                : `CONTEXT: The customer has just moved to the "Your Receptionist's Number" screen, but no local number could be found for their area yet. Continue the SAME conversation naturally — do NOT restart or re-introduce yourself. In ONE short, warm sentence, tell them ${usesVobiz() ? "we are preparing their business number" : "they can tap \"Find More Options\" to search another city for their business number"}. Never pushy.`
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callStatus, selectedNumber, isLoading, agentDisplayName]);

    const handleOpenPicker = () => {
        if (pickerOpen) {
            setPickerOpen(false);
            return;
        }
        setPickerOpen(true);
        // Address field ko business ki location se seed karo, taaki user ko
        // shuruaat me hi apni city dikhe.
        const country = usesVobiz() ? "IN" : pickerCountry || bizCountry;
        const city = usesVobiz()
            ? IN_DEFAULT_LOCATION.city
            : pickerCity || bizCity;
        const stateCode = usesVobiz()
            ? IN_DEFAULT_LOCATION.stateCode
            : pickerState || bizState;
        // No seed on the India site — there is no field to seed.
        const seed = usesVobiz()
            ? ""
            : [city, stateCode].filter(Boolean).join(", ") || country;
        if (seed) {
            pickerSeededRef.current = true;
            setPickerLocationAddress(seed);
        }
        if (!country) {
            setPickerError(
                "Couldn't determine your business location. Type a city above to search."
            );
            return;
        }
        if (pickerNumbers.length === 0) {
            fetchNumbersFor(country, city, stateCode);
        }
    };

    const handleCopy = () => {
        if (!selectedNumber) return;
        navigator.clipboard
            .writeText(selectedNumber)
            .then(() => {
                setCopiedFlash(true);
                setTimeout(() => setCopiedFlash(false), 1800);
            })
            .catch(() => {
                /* clipboard blocked — chup-chaap chhod do, number screen pe hai hi */
            });
    };

    // Telnyx ke region_information se number ki asli city/state nikaalo — wahi
    // agent row pe voip_number_city / voip_number_state me jaata hai. Priority
    // NumberAssign.js wali hi hai: region_information → searched city/state → "".
    const resolveNumberRegion = (phoneNumber) => {
        const picked = pickerNumbers.find((n) => n.phone_number === phoneNumber);
        const regions = picked?.region_information || [];
        const cityRegion = regions.find(
            (r) =>
                r.region_type === "rate_center" ||
                r.region_type === "rate-center" ||
                r.region_type === "city" ||
                r.region_type === "locality"
        );
        const stateRegion = regions.find(
            (r) => r.region_type === "state" || r.region_type === "administrative_area"
        );
        // "OWENSBORO" → "Owensboro"
        const titleCase = (s) =>
            String(s || "")
                .toLowerCase()
                .replace(/\b\w/g, (c) => c.toUpperCase());
        return {
            city: titleCase(cityRegion?.region_name) || pickerCity || bizCity || "",
            state: (stateRegion?.region_name || pickerState || bizState || "").toUpperCase(),
        };
    };

    // Number ko agent pe assign karo — wahi sequence jo NumberAssign.js me hai.
    // createNumberOrder sirf production me chalta hai (dev/staging me asli
    // purchase nahi karte, na hi user_phonenumbers row banti hai); updateAgent
    // dono jagah chalta hai taaki agent row par number set ho jaye aur agli
    // screen use dikha sake.
    //
    // Provider yahan se nahi chunna padta — createNumberOrder khud site ke
    // hisaab se Vobiz (India) ya Telnyx pe jaata hai, dekho
    // utils/apiBackend.js ka numberProviderPath().
    const assignNumber = async (phoneNumber) => {
        const { city, state } = resolveNumberRegion(phoneNumber);
        if (process.env.REACT_APP_ENV === "production") {
            const orderRes = await orderNumber(phoneNumber, agentId);
            // Purchase fail hui to number agent pe assign NAHI karna — warna
            // wo number lag jaata hai jo carrier ne becha hi nahi, aur user ko
            // success dikh jaata hai.
            if (orderRes && orderRes.success === false) {
                throw new Error(orderRes.message || "Could not purchase the number");
            }
        }
        await updateAgent(agentId, {
            voip_numbers: [phoneNumber],
            voip_numbers_created: new Date(),
            assignNumFree: 1,
            isNumActivated: 1,
            isDeactivated: false,
            agentStatus: true,
            ...(city ? { voip_number_city: city } : {}),
            ...(state ? { voip_number_state: state } : {}),
            // Pounce agent ke case me prompt/tools receptionist transition me nahi
            // badalne chahiye — sirf number assign hona chahiye.
            ...(isPounce
                ? { agentType: "pounce", role: "pounce" }
                : { applyGoLiveTransition: true }),
        });
    };

    // Picker khula ho to "Use This Number" — chuna hua number upar le aao aur
    // panel band kar do (abhi kuch khareeda nahi jaata). Warna "Continue with
    // this number" — number assign karke agli screen.
    // /agent-live pe confetti ka nishaan. Navigate state + sessionStorage dono —
    // kuch guards navigate state gira dete hain, key un cases me bacha leti hai.
    const goLiveWithCelebration = () => {
        if (isPounce) {
            navigate("/dashboard", { replace: true });
            return;
        }
        try {
            sessionStorage.setItem(CELEBRATE_KEY, "1");
        } catch {
            /* storage blocked */
        }
        navigate("/agent-live", { state: { celebrate: true } });
    };

    const handlePrimaryCta = async () => {
        if (pickerOpen && pickerSelectedNumber) {
            setSelectedNumber(pickerSelectedNumber);
            setPickerOpen(false);
            trackEvent("b_flow_number_changed", { screen: "receptionist_number" });
            return;
        }
        if (!selectedNumber || assignRunningRef.current) return;

        // Pehle se assigned hai → dobara purchase mat karo, seedha aage.
        // `celebrate` /agent-live pe confetti chalata hai — sirf is CTA se aane
        // par, back/app-kill se laut kar aane par nahi.
        if (isAssigned) {
            markSetupStep("phoneNumberAssigned", agentId);
            goLiveWithCelebration();
            return;
        }

        assignRunningRef.current = true;
        setAssigning(true);
        try {
            await assignNumber(selectedNumber);
            await markSetupStep("phoneNumberAssigned", agentId);
            setIsAssigned(true);
            trackEvent("b_flow_number_confirmed", { screen: "receptionist_number" });
            // Loader hata do taaki success popup saaf dikhe. assignRunningRef
            // TRUE hi rehta hai — navigate hone tak koi doosra tap purchase na
            // chala de.
            setAssigning(false);
            setPopupType("success");
            setPopupMessage("Number assigned successfully");
            setTimeout(goLiveWithCelebration, 1500);
        } catch (err) {
            console.error("[ReceptionistNumber] number assign failed:", err);
            setPopupType("failed");
            setPopupMessage(
                err?.message || "Couldn't assign this number. Please try again."
            );
            // Fail hua to lock chhod do taaki user dobara koshish kar sake.
            assignRunningRef.current = false;
            setAssigning(false);
        }
    };

    const numberLabel = agentDisplayName
        ? `${agentDisplayName}'s Number`
        : "Your Number";
    const handleBack = () => {
        if (isPounce) {
            navigate("/dashboard", { replace: true });
        } else {
            navigate(-1);
        }
    };

    const isPickerCommit = pickerOpen && !!pickerSelectedNumber;

    return (
        <>
            {popupMessage && (
                <PopUp
                    type={popupType}
                    message={popupMessage}
                    onClose={() => setPopupMessage("")}
                />
            )}

            {((isLoading && !selectedNumber) || assigning) && (
                <div className={styles.loadingOverlay}>
                    <Loader2 />
                </div>
            )}

            <div className={`${styles.containerBox} ${styles.containerBoxWizard}`}>
                <div className={styles.container}>
                    <div style={{ paddingTop: "1rem", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                        <button
                            type="button"
                            onClick={handleBack}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "6px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                color: "#24252C",
                            }}
                            aria-label="Back"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div className={`${styles.titleBar} ${styles.titleBarPicker}`} style={{ paddingTop: "0.5rem" }}>
                        <h4 className={`${styles.lightTitle} ${styles.pickerTitleLight}`}>
                            {isPounce ? "Your Outbound Caller Agent's" : "Your Receptionist's"}
                        </h4>
                        <h5 className={`${styles.boldTitle} ${styles.pickerTitleBold}`}>
                          Business Number
                        </h5>
                        <p className={styles.pickerSubtitle}>
                            {selectedNumber ? (
                                <>
                                    We have assigned a premium, local{" "}
                                    <b className={styles.highlight}>{cityDisplay}</b> number to{" "}
                                    <b className={styles.highlight}>
                                        {agentDisplayName || (isPounce ? "your Outbound Caller agent" : "your receptionist")}
                                    </b>
                                    {isPounce ? ", your AI Lead Qualification Agent." : ", your AI Receptionist."}
                                </>
                            ) : pickerError === US_CA_ONLY ? (
                                <>
                                    Phone numbers aren't available in your country yet.{" "}
                                    {US_CA_ONLY}
                                </>
                            ) : (
                                <>
                                    We couldn't find a local number for{" "}
                                    <b className={styles.highlight}>
                                        {agentDisplayName || (isPounce ? "your Outbound Caller agent" : "your receptionist")}
                                    </b>{" "}
                                    yet.
                                    {!usesVobiz() && (
                                        <>
                                            {" "}Use{" "}
                                            <b className={styles.highlight}>Find More Options</b> below to
                                            search a different city.
                                        </>
                                    )}
                                </>
                            )}
                        </p>
                    </div>

                    <div className={`${styles.phoneCard} ${styles.phoneCardPicker}`}>
                        {selectedNumber ? (
                            <div className={styles.currentNumberWrap}>
                                <span className={styles.currentNumberLabel}>{numberLabel}</span>
                                <span className={`${styles.number} ${styles.numberInline}`}>
                                    {selectedNumber}
                                </span>
                            </div>
                        ) : (
                            <span className={`${styles.number} ${styles.numberUnavailablePicker}`}>
                                {isLoading || pickerLoading ? "Loading..." : "No number available"}
                            </span>
                        )}

                        <div className={styles.copyWrap}>
                            {copiedFlash && <span className={styles.copyTooltip}>Copied</span>}
                            <button
                                type="button"
                                className={styles.copyBtn}
                                onClick={handleCopy}
                                disabled={!selectedNumber}
                                title="Copy number"
                            >
                                <img src="/svg/copy-icon2.svg" alt="copy" />
                            </button>
                        </div>
                    </div>

                    {!usesVobiz() && (
                        <button
                            type="button"
                            onClick={handleOpenPicker}
                            className={styles.findMoreBtn}
                            aria-expanded={pickerOpen}
                            aria-controls="bflow-inline-picker"
                        >
                            <span className={styles.findMoreIcon} aria-hidden="true">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M4 20h4l10-10-4-4L4 16v4z"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path d="M14 6l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                                </svg>
                            </span>
                            <span className={styles.findMoreText}>
                                {pickerOpen ? "Close" : "Find More Options"}
                            </span>
                        </button>
                    )}

                    {!usesVobiz() && pickerOpen && (
                        <div id="bflow-inline-picker" className={styles.pickerPanel}>
                            {/* India site: numbers come from one pool, so there
                                is no city to search — the list below is it. */}
                            <div
                                className={styles.pickerInputRow}
                                hidden={usesVobiz()}
                            >
                                <div className={styles.pickerLocationInput}>
                                    <GoogleAddressInputWithDropdown
                                        ref={pickerGoogleInputRef}
                                        value={pickerLocationAddress}
                                        onChange={(val) => setPickerLocationAddress(val || "")}
                                        placeholder="Search city (e.g., Irvine, CA)"
                                    />
                                </div>
                                <button
                                    type="button"
                                    className={styles.pickerEditBtn}
                                    onClick={() => pickerGoogleInputRef.current?.focus?.()}
                                    aria-label="Edit location"
                                    title="Edit location"
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path
                                            d="M4 20h4l10-10-4-4L4 16v4z"
                                            stroke="#6b7280"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path d="M14 6l4 4" stroke="#6b7280" strokeWidth="1.8" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>

                            {pickerLoading ? (
                                <div className={styles.pickerLoading}>Loading numbers…</div>
                            ) : pickerError ? (
                                <div role="alert" className={styles.pickerErrorBox}>
                                    {pickerError}
                                </div>
                            ) : pickerNumbers.length === 0 ? (
                                <div className={styles.pickerEmpty}>
                                    No numbers available for this location.<br />
                                    <span className={styles.pickerEmptyHint}>
                                        Try a different city or state above.
                                    </span>
                                </div>
                            ) : (
                                <div
                                    role="radiogroup"
                                    aria-label="Available phone numbers"
                                    className={styles.pickerList}
                                >
                                    {pickerNumbers.map((n) => {
                                        const isPicked = n.phone_number === pickerSelectedNumber;
                                        return (
                                            <button
                                                key={n.phone_number}
                                                type="button"
                                                role="radio"
                                                aria-checked={isPicked}
                                                onClick={() => setPickerSelectedNumber(n.phone_number)}
                                                className={styles.pickerOption}
                                            >
                                                <span>{n.phone_number}</span>
                                                <span
                                                    className={`${styles.pickerRadio}${isPicked ? ` ${styles.pickerRadioPicked}` : ""}`}
                                                    aria-hidden="true"
                                                />
                                            </button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    )}

                    <div className={styles.benefitsBox}>
                        <h6 className={styles.benefitsTitle}>Benefits:</h6>
                        <ul className={styles.benefitsList}>
                            {[
                                "Use this number for call forwarding",
                                "Keep your existing business number",
                                `Let ${agentDisplayName || "your receptionist"} answer forwarded calls`,
                                "Use this number publicly only if you want",
                            ].map((text) => (
                                <li key={text} className={styles.benefitsItem}>
                                    <span className={styles.benefitsCheck} aria-hidden="true">
                                        <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                                            <path
                                                d="M3.5 8L6.5 11L12.5 5"
                                                stroke="#fff"
                                                strokeWidth="2.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                    <span className={styles.benefitsText}>{text}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className={`${styles.looksGoodBtn} ${styles.looksGoodBtnWizard}`}>
                        <div className={styles.ctaWrap}>
                            <AnimatedButton
                                label={
                                    isPickerCommit
                                        ? "Use This Number"
                                        : assigning
                                            ? "Assigning Number..."
                                            : "Continue with this number"
                                }
                                onClick={handlePrimaryCta}
                                disabled={
                                    isLoading || assigning || (!selectedNumber && !isPickerCommit)
                                }
                                positionType="relative"
                                bottom="5px"
                            />
                            <p className={styles.pickerNote}>
                                {isPickerCommit ? (
                                    isPounce
                                        ? "Confirm to use this number for your Outbound Caller agent."
                                        : "Confirm to use this number for your receptionist."
                                ) : isPounce ? (
                                    <>
                                        Next, your Outbound Caller AI agent will use this number for high-speed outbound calls.
                                    </>
                                ) : (
                                    <>
                                        Next, we'll help you forward calls from your business number to{" "}
                                        <strong>{agentDisplayName || "your receptionist"}</strong>.
                                    </>
                                )}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReceptionistNumber;
